/* eslint-disable no-useless-catch */
import axios from "axios";

module.exports.createCompany = async (company) => {
  let companyUpdate;
  try {
    companyUpdate = await axios.post("/api/v2/companies", company);
  } catch (error) {
    throw error;
  }
  return companyUpdate.data;
};

module.exports.patchCompany = async (company_id, company) => {
  let companyUpdate;
  try {
    companyUpdate = await axios.patch(
      `/api/v2/companies/${company_id}`,
      company
    );
  } catch (error) {
    throw error;
  }
  return companyUpdate.data;
};

module.exports.getCompany = async (company_id) => {
  let companyUpdate;
  try {
    companyUpdate = await axios.get(`/api/v2/companies/${company_id}`);
  } catch (error) {
    throw error;
  }
  return companyUpdate.data;
};

module.exports.getCompanies = async ({
  companyIds,
  visibility,
  limit = 30,
}) => {
  let requestUrl = "/api/v2/companies?limit=" + limit;

  let companyUpdate;

  if (companyIds && companyIds.length) {
    requestUrl = requestUrl + "&company_ids=" + companyIds;
  }

  if (visibility) {
    requestUrl = requestUrl + "&visibility=" + visibility;
  }

  try {
    companyUpdate = await axios.get(requestUrl);
  } catch (error) {
    throw error;
  }
  return companyUpdate.data;
};
